import { render, staticRenderFns } from "./videoRecord.vue?vue&type=template&id=7bb993d0&"
import script from "./videoRecord.vue?vue&type=script&lang=js&"
export * from "./videoRecord.vue?vue&type=script&lang=js&"
import style0 from "./videoRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports